
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHydraulicSeparator as ObiHydraulicSeparatorElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-hydraulic-separator.js';
 
 
 

 
 export const ObiHydraulicSeparator = createComponent({
   react: React,
   tagName: 'obi-hydraulic-separator',
   elementClass: ObiHydraulicSeparatorElement,
   events: {
     
   }
  });
 
 